import React from "react";
import { styled } from "@mui/material/styles";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TimePicker } from "antd";
import Switch from "@mui/material/Switch";
const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const Configuration = () => {
  let timeArray = [];
  for (let index = 1; index < 46; index++) {
    const obj = {
      name: `${index} Min`,
    };
    timeArray = [...timeArray, obj];
  }

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.65rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      <div className="main_info_container">
        <div className="info_rs_header">
          <span className="Info_rs_header">Delivery Timings</span>
          <span className="Info-rs_reco"></span>
        </div>
        <div className="info_input_container">
          <div className="info_contain_input">
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                PREPARATION TIME
              </InputLabel>
              <TimePicker className="input_container" />
            </div>
            <div className="input_box_container"></div>
            <div className="input_box_container"></div>
            <div className="input_box_container"></div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                MINIMUM DELIVERY TIME
                <sup className="star_colour">*</sup>
              </InputLabel>
              <TextField
                id="custom-select"
                select
                variant="outlined"
                defaultValue="15 Min"
                size="small"
                className="input_container"
                placeholder="select time"
                // onChange={(e) => setdeliverycommission(e.target.value)}
                // value={deliverycommission}
              >
                {timeArray.map((data, index) => (
                  <MenuItem value={data.name} key={index}>
                    {data.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                MAXIMUM DELIVERY TIME
                <sup className="star_colour">*</sup>
              </InputLabel>
              <TextField
                id="custom-select"
                select
                variant="outlined"
                defaultValue="45 Min"
                size="small"
                className="input_container"
                placeholder="select time"
                // onChange={(e) => setdeliverycommission(e.target.value)}
                // value={deliverycommission}
              >
                {timeArray.map((data, index) => (
                  <MenuItem value={data.name} key={index}>
                    {data.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
        </div>
        <div
          className="input_box_container"
          style={{
            margin: "3vh 0 1vh",
          }}
        >
          <InputLabel sx={input_lable_style} htmlFor="custom-input">
            SET TIME SLOT
          </InputLabel>
        </div>
        <div className="active_container">
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Monday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Tuesday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Wednesday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Thursday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Friday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">saturday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
          <div className="slot_box">
            <div className="slot_box_left">
              <span className="slot_title">Sunday</span>
              <TimePicker className="slot_timer_input" />
            </div>
            <div className="slot_box_midle">
              <span className="slot_title">To</span>
            </div>
            <div className="slot_box_right">
              <TimePicker className="slot_timer_input" />
              <Android12Switch />
            </div>
          </div>
        </div>
        <div className="map_view_btn">SAVE</div>
      </div>
    </>
  );
};

export default Configuration;
